import { StoresDictionary } from '@/Types/api/Dictionaries';

export const filterStoreByStoreGroupId = (stores: StoresDictionary[] = [], storeGroupId?: number): StoresDictionary[] => {
    if (!storeGroupId) {
        return [];
    }

    return stores.filter((store) => store.store_group_id === storeGroupId);
};
